import { IMaterialIcon } from '../typings/models';

// tslint:disable:max-classes-per-file
export class VirtualRepeaterCellComponent implements angular.IComponentOptions {
    public static $name: string = 'virtualRepeaterCell';

    public bindings: any = {
        displayText: '@',
        heading: '@',
        icon: '<?',
        iconText: '@?',
        searchTerm: '<',
        width: '<'
    };

    public controller = VirtualRepeaterCellController;

    public template: string = require('!!html-loader!./VirtualRepeaterCellView.html');

    public transclude: boolean = true;
}

export class VirtualRepeaterCellController implements angular.IComponentController {
    private static $inject: string[] = [
        '$element'
    ];

    /** The string to display inside the cell */
    private displayText: string;

    /** The heading to display if the screen is too small for a standard table */
    private heading: string;

    /** A term to highlight if search is active */
    private searchTerm: string;

    /** A percentage value to use for flex */
    private width: number;

    private icon: IMaterialIcon;

    constructor(
        private $element: angular.IAugmentedJQuery
    ) { }

    public $onInit() {
        // We want attributes to be applied to the original (outer) element, best place to do that is here
        this.$element.addClass('layout-row layout-gt-sm-column flex-100');
        this.$element.addClass('flex-gt-sm-' + this.width);
    }
}
